<template>
  <qx-card title="列表">
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <el-button type="primary" plain @click="() => toEdit()">
          <i class="iconfont">&#xe6ab;</i>切换
        </el-button>
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          />
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column prop="control" label="操作" width="160">
            <template slot-scope="scope">
              <section>
                <!-- 操作按钮 -->
                <qx-permpisions permpisions="">
                  <span class="primary cur" @click="toDetail(scope.row)">查看</span>
                </qx-permpisions>
              </section>
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  orderTimeDriverChangeList,
} from 'api/operate';
export default {
  mixins: [
    tableMixin,
  ],
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'createDate',
            label: '发起时间',
          },
          {
            prop: 'formerUserName',
            label: '原司机',
          },
          {
            prop: 'formerUserPhone',
            label: '原司机手机号',
          },
          {
            prop: 'receiveUserName',
            label: '接收司机',
          },
          {
            prop: 'receiveUserPhone',
            label: '接收司机手机号',
          },
          {
            prop: 'originUserName',
            label: '发起人',
          },
          {
            prop: 'stateName',
            label: '状态',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: orderTimeDriverChangeList,
    toDetail (item, type = '') {
      this.jump({
        label: '切换司机详情',
        url: `/manage/operate/order/deal/orderDetailTab/driver/detail?id=${item.id}&type=${type}`,
        full: true,
      });
    },
    toEdit () {
      this.jump({
        label: '切换司机',
        url: `/manage/operate/order/deal/orderDetailTab/driver/edit?orderId=${this.$route.query.id}`,
        full: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
